import React, { useState } from 'react';

const FAQOne = () => {
  const [active, setActive] = useState(-1); // none open by default
  const faqs = [
    {
      q: 'How does my donation help Rayyan Aid programs?',
      a: 'Your gift funds education, healthcare, nutrition and emergency relief. We partner with communities to deliver practical support—like school meals, medical aid and clean water—while tracking every naira to outcomes.'
    },
    {
      q: 'Can I donate monthly and change the amount later?',
      a: 'Yes. Monthly giving is flexible—you can update or cancel anytime. Monthly support helps us plan sustainably and respond quickly during emergencies.'
    },
    {
      q: 'Do you provide reports on the impact of my donation?',
      a: 'We share periodic updates and stories from the field, including program milestones and how funds were used, so you can see the difference you make.'
    },
    {
      q: 'How else can I support beyond donating?',
      a: 'You can volunteer, fundraise with friends, or partner with us as an organization. Advocacy and sharing our work also helps us reach more families.'
    }
  ];

  const toggle = (idx) => {
    setActive((prev) => (prev === idx ? -1 : idx));
  };

  return (
    <section className="faq-one">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-xl-6">
            <div className="faq-one__left">
              <div className="section-title text-left sec-title-animation animation-style2">
                <div className="section-title__tagline-box">
                  <span className="section-title__tagline">FAQ – Rayyan Aid</span>
                </div>
                <h2 className="section-title__title title-animation">Answers about <span>donating</span> and <span>supporting</span></h2>
              </div>
              {/* <p className="faq-one__text">Find quick answers about ways to give, monthly support, transparency and how to get involved with Rayyan Aid.</p> */}
              <ul className="accrodion-grp faq-one-accrodion list-unstyled" data-grp-name="faq-one-accrodion-1">
                {faqs.map((item, idx) => (
                  <li key={idx} className={`accrodion ${active === idx ? 'active' : ''}`}>
                    <div className="accrodion-title" onClick={() => toggle(idx)} role="button" tabIndex={0}>
                      <h4>{item.q}</h4>
                    </div>
                    <div className="accrodion-content" style={{ display: active === idx ? 'block' : 'none' }}>
                      <div className="inner"><p>{item.a}</p></div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="col-xl-6">
            <div className="faq-one__right wow slideInRight mt-0" data-wow-delay="100ms" data-wow-duration="2500ms">
              <div className="faq-one__img-box">
                <div className="faq-one__img"><img src="assets/images/jwmzSfYK3Csboy.jpg" alt="Rayyan Aid gallery 1" /></div>
                <div className="faq-one__img-2"><img src="assets/images/6%20(1).jpg" alt="Rayyan Aid gallery 2" /></div>
                <div className="faq-one__img-3"><img src="assets/images/5%20(1).jpg" alt="Rayyan Aid gallery 3" /></div>
                <div className="faq-one__shape-1 float-bob-y"><img src="assets/images/shapes/faq-one-shape-1.png" alt="" /></div>
                <div className="faq-one__video-link">
                  <a href="https://www.youtube.com/watch?v=Get7rqXYrbQ" className="video-popup">
                    <div className="faq-one__video-icon"><span className="fa fa-play"></span><i className="ripple"></i></div>
                  </a>
                </div>
                <div className="faq-one__shape-2 rotate-me"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQOne;
